import React from 'react';

import ErrorIcon from '@atlaskit/icon/glyph/error';

import {
  ContainerStyled,
  MessageStyled,
} from './NoPermissionToViewTestCase.styled';

export default function NoPermissionToViewTestCase(): JSX.Element {
  return (
    <ContainerStyled>
      <ErrorIcon
        primaryColor='var(--ds-icon-danger, var(--ds-fb-icon-danger))'
        label=''
      />
      <MessageStyled>
        You don’t have permission to view this test case
      </MessageStyled>
    </ContainerStyled>
  );
}
